(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["design-samples"]) return;
  try {
    

$(window).load(function() {

    /*============================================================================
    Masonry Grid
    ==============================================================================*/
    var design_container = $('.design-masonry-container');
    design_container.masonry({
        itemSelector: '.design-masonry-item',
        gutter: 30,
        isFitWidth: true
    });

    $('.design-masonry-container').fadeTo('slow',1.0);

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-1"]) return;
  try {
    

/*============================================================================
FAQ Accordion
==============================================================================*/
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
        $(".radio-active .check-indicator").removeClass("fa-chevron-up").addClass("fa-chevron-down");
        $(".radio-active").removeClass("radio-active");
        $(".accordion-show").removeClass("accordion-show");

        this.classList.toggle("radio-active");
        this.nextElementSibling.classList.toggle("accordion-show");
        $(this).find("i.check-indicator").removeClass("fa-chevron-down").addClass("fa-chevron-up");
    }
};


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-2"]) return;
  try {
    

/*============================================================================
FAQ Accordion
==============================================================================*/
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
        $(".radio-active .check-indicator").removeClass("fa-chevron-up").addClass("fa-chevron-down");
        $(".radio-active").removeClass("radio-active");
        $(".accordion-show").removeClass("accordion-show");

        this.classList.toggle("radio-active");
        this.nextElementSibling.classList.toggle("accordion-show");
        $(this).find("i.check-indicator").removeClass("fa-chevron-down").addClass("fa-chevron-up");
    }
};


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-3"]) return;
  try {
    

/*============================================================================
FAQ Accordion
==============================================================================*/
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
        $(".radio-active .check-indicator").removeClass("fa-chevron-up").addClass("fa-chevron-down");
        $(".radio-active").removeClass("radio-active");
        $(".accordion-show").removeClass("accordion-show");

        this.classList.toggle("radio-active");
        this.nextElementSibling.classList.toggle("accordion-show");
        $(this).find("i.check-indicator").removeClass("fa-chevron-down").addClass("fa-chevron-up");
    }
};


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-4"]) return;
  try {
    

/*============================================================================
FAQ Accordion
==============================================================================*/
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
        $(".radio-active .check-indicator").removeClass("fa-chevron-up").addClass("fa-chevron-down");
        $(".radio-active").removeClass("radio-active");
        $(".accordion-show").removeClass("accordion-show");

        this.classList.toggle("radio-active");
        this.nextElementSibling.classList.toggle("accordion-show");
        $(this).find("i.check-indicator").removeClass("fa-chevron-down").addClass("fa-chevron-up");
    }
};


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-5"]) return;
  try {
    

/*============================================================================
FAQ Accordion
==============================================================================*/
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
        $(".radio-active .check-indicator").removeClass("fa-chevron-up").addClass("fa-chevron-down");
        $(".radio-active").removeClass("radio-active");
        $(".accordion-show").removeClass("accordion-show");

        this.classList.toggle("radio-active");
        this.nextElementSibling.classList.toggle("accordion-show");
        $(this).find("i.check-indicator").removeClass("fa-chevron-down").addClass("fa-chevron-up");
    }
};


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-video-carousel"]) return;
  try {
    
	$(document).ready(function(){
	  $('.rotating').slick({
	    prevArrow: '.prev-Arrow',
	    nextArrow: '.next-Arrow',
	    infinite: true,
	    dots: false,
	    speed: 300,
	    slidesToShow: 3,
	    slidesToScroll: 1,
	    autoplay: true,
	    autoplaySpeed: 7000,
	    responsive: [
	      {
	        breakpoint: 940,
	        settings: {
	          slidesToShow: 2,
	          slidesToScroll: 2
	        }
	      },
	      {
	        breakpoint: 680,
	        settings: {
	          slidesToShow: 1,
	          slidesToScroll: 1
	        }
	      }
	    ]
	  });
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"]) return;
  try {
    

$(document).ready(function(){
	$('.5secCarousel').slick({
	arrows: false,
	variableWidth: true,
	dots: false,
	centerMode: true,
	infinite: true,
	speed: 300,
	slidestoScroll: 1,
	focusOnSelect: true,
	autoplay: true,
	autoplaySpeed: 5000,
	responsive: [
	  {
	    breakpoint: 940,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  },
	  {
	    breakpoint: 680,
	    settings: {
	      slidesToShow: 1,
	      slidesToScroll: 1
	    }
	  }
	]
	});

	$('.7secCarousel').slick({
	arrows: false,
	variableWidth: true,
	dots: false,
	centerMode: true,
	infinite: true,
	speed: 300,
	slidesToScroll: 1,
	focusOnSelect: true,
	autoplay: true,
	autoplaySpeed: 7000,
	responsive: [
	  {
	    breakpoint: 940,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  },
	  {
	    breakpoint: 680,
	    settings: {
	      slidesToShow: 1,
	      slidesToScroll: 1
	    }
	  }
	]
	});

	$('.10secCarousel').slick({
	arrows: false,
	dots: false,
	variableWidth: true,
	centerMode: true,
	infinite: true,
	speed: 300,
	slidesToScroll: 1,
	focusOnSelect: true,
	autoplay: true,
	autoplaySpeed: 10000,
	responsive: [
	  {
	    breakpoint: 940,
	    settings: {
	      slidesToShow: 2,
	      slidesToScroll: 2
	    }
	  },
	  {
	    breakpoint: 680,
	    settings: {
	      slidesToShow: 1,
	      slidesToScroll: 1
	    }
	  }
	]
	});
});


  } catch(e) { console.error(e); }
})();
})();
